// removed by extract-text-webpack-plugin
module.exports = {"header":"UpgradeEffectContent_header--2Qo3A","title":"UpgradeEffectContent_title--2JCDP","base":"UpgradeEffectContent_base--3djgL","tableTitle":"UpgradeEffectContent_tableTitle--1dOdN","titleText":"UpgradeEffectContent_titleText--2qMF6","description":"UpgradeEffectContent_description--1xhd8","content":"UpgradeEffectContent_content--9B6vM","bonusHolder":"UpgradeEffectContent_bonusHolder--2-gtP","warning":"UpgradeEffectContent_warning--2F0ud"};


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingCard/components/UpgradeEffectContent/UpgradeEffectContent.scss
// module id = 2114
// module chunks = 11